/// <amd-module name="VSS/Redux/Modules/VSSPageData/VSSPageDataModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { IVSSPageDataAwareState } from "./VSSPageDataContracts";
import { vssPageDataSaga } from "./VSSPageDataSaga";
import { vssPageDataReducer } from "./VSSPageDataReducer";

export const VSSPageDataModule: ISagaModule<IVSSPageDataAwareState> = {
    id: "vss-page-data",
    reducerMap: {
        vssPageData: vssPageDataReducer
    },
    sagas: [vssPageDataSaga]
};
